import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SystemService} from './system.service';

/** Inject With Credentials into the request */

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(public auth: SystemService) {}
  
  
  
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // // Clone the request to add the new header
        // if (req.url.includes("login")){
        //     return next.handle(req);
        // }else{
        //     const clonedRequest = req.clone({ setHeaders: {'withCredentials' : 'true' } });
        //     return next.handle(clonedRequest);
        // }'Content-Type', 'application/json; charset=utf-8'
        // let contentType:string = req.headers.get("Content-Type");
        const url: string = req.url;
        
        // if (contentType && contentType.includes("application/json")){
        //     const clonedRequest = req.clone({ setHeaders: {'Content-Type' : 'application/json; charset=utf-8' } });
        //     return next.handle(clonedRequest).pipe(
        //        // retry(1),
        //         catchError((error: HttpErrorResponse) => {
        //             let errorMessage = '';
        //             if (error.error instanceof ErrorEvent) {
        //                 // client-side error
        //                 errorMessage = `Error: ${error.error.message}`;
        //             } else {
        //                 // server-side error
        //                 errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
        //             }
        //             console.log(errorMessage);
        //             return throwError(errorMessage);
        //         })
        //     );
        // }else 
        if (url.includes('/ypm/api/')){
            const clonedRequest = req.clone({ setHeaders: {'Content-Type' : 'application/json; charset=UTF-8' } });
            return next.handle(clonedRequest);
            
            // .pipe(
            //     //retry(1),
            //     catchError((error: HttpErrorResponse) => {
            //         
            //         let errorMessage = '';
            //         if (error.error instanceof ErrorEvent) {
            //             // client-side error
            //             errorMessage = `Error: ${error.error.message}`;
            //         } else {
            //             // server-side error
            //             errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
            //         }
            //         console.log(errorMessage);
            //         return throwError(errorMessage);
            //     })
            // );
        }else {
            return next.handle(req);
        }
        // Pass control to the next request
        
    }
}
